<template>
  <v-container class="pa-0" v-if="$auth.check()">
    <v-row>
      <v-col :cols="12">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Subscriptions',
};
</script>
